import styled, { css } from "styled-components/macro";
import { rgba } from "polished";

import { colors, zIndex } from "shared/styles/constants";

export interface StyledOverlayProps {
  hasBackground?: boolean;
}

export const StyledOverlay = styled.div<StyledOverlayProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  z-index: ${zIndex.above};

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ hasBackground }) =>
    hasBackground &&
    css`
      background-color: ${rgba(colors.black, 0.8)};
    `}
`;
